import { BaseApiResponse } from '../../../../../api/shared'
import { ThisConnector } from '../../../../../api/connector'

export interface DeleteJiraCredentialArgs {
  organizationUuid: string
  credentialId: string
}

export function deleteJiraCredential(
  this: ThisConnector,
  { organizationUuid, credentialId }: DeleteJiraCredentialArgs
): Promise<BaseApiResponse> {
  return this.connector.executeDelete<BaseApiResponse>(
    `/${organizationUuid}/bugtrackers/jira/credentials/${credentialId}`
  )
}
